import { render, staticRenderFns } from "./ExpertWorkPlace.vue?vue&type=template&id=79e4a005&scoped=true"
import script from "./ExpertWorkPlace.vue?vue&type=script&lang=js"
export * from "./ExpertWorkPlace.vue?vue&type=script&lang=js"
import style0 from "./ExpertWorkPlace.vue?vue&type=style&index=0&id=79e4a005&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e4a005",
  null
  
)

export default component.exports